import { Injectable } from '@angular/core';

import * as messages from '../../../messages/messages.json';

type MessagesJSON = typeof import('../../../messages/messages.json');

export type Messages = MessagesJSON[keyof MessagesJSON]['default'];

@Injectable({
  providedIn: 'root'
})
export class MessagesService {

  public getMessages(locale: string, country = ''): Messages {
    locale = locale.toLowerCase();
    country = country.toUpperCase();

    const byLocale = messages[locale] || {};
    const byDefault = byLocale.default || {};
    const byCountry = byLocale[country] || {};
    return { ...byDefault, ...byCountry };
  }
}
